import { Flex, Typography } from "antd";
import { colors } from "shared/theme/color";
import { textPx } from "shared/constants/zoom";

// Card section header (prototype .card-title/.card-sub): display-font title
// with a muted one-line subtitle. Shared by the card-wrapped form/table
// sections so the heading styling lives in one place.
const CardSectionTitle = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) => (
  <Flex vertical>
    <Typography.Title
      level={5}
      style={{
        margin: 0,
        fontFamily: "var(--font-display)",
        fontSize: textPx(17),
        letterSpacing: "-0.01em",
      }}
    >
      {title}
    </Typography.Title>
    {subtitle && (
      <Typography.Text style={{ color: colors.ink2, fontSize: textPx(13), marginTop: 4 }}>
        {subtitle}
      </Typography.Text>
    )}
  </Flex>
);

export default CardSectionTitle;
